export const isValidUrl = (s: string) =>
  /^(https?:\/\/)[^\s/$.?#].[^\s]*\.[a-z]{2,}(\/[^\s]*)?$/.test(s)
